import React from 'react';
import { Section } from './Section';
import { patientFactors } from '../data/workflow';
export function WorkflowChallenge() {
  return <Section tone="white" title="A more structured approach to obesity care" subtitle="The challenge isn't simply knowing the guidelines. It's knowing what to review, when to review it, and how to organize the process." cta="I want a clearer approach to obesity care" ctaNote="One-Time Payment of $27 USD · Instant Digital Access · 7-Day Money-Back Guarantee" data-id="element-297" data-mp="2r9mqj2873iql">
      <div className="mx-auto max-w-3xl" data-id="element-298" data-mp="28l7ycbm55yo7">
        <p className="text-center text-lg font-semibold text-ink" data-id="element-299" data-mp="2mat8cwhyr3k3">Every patient presents a different combination of factors.</p>
        <ul className="mt-5 flex flex-wrap justify-center gap-2.5" data-id="element-300" data-mp="2hja577sk3lje">
          {patientFactors.map(factor => <li key={factor} className="rounded-full border border-brand/20 bg-brand-soft px-4 py-2 text-[15px] font-semibold text-brand-dark" data-id="element-301" data-mp="1ttfr6mwi3qxk">
              {factor}
            </li>)}
        </ul>

        <div className="mt-10 space-y-5 text-[17px] leading-relaxed text-muted sm:text-lg" data-id="element-302" data-mp="2wp4002ikztny">
          <p data-id="element-303" data-mp="31fu65hyu00jp">
            When all these considerations come together, organizing a comprehensive clinical assessment can become
            challenging, <strong className="text-ink" data-id="element-304" data-mp="36dvp82w9bzv6">especially when time is limited.</strong>
          </p>
          <p data-id="element-305" data-mp="28s83qd1cb1yf">
            You may already have access to excellent clinical guidelines. You may understand the different treatment
            approaches. You may have years of professional experience.
          </p>
          <p data-id="element-306" data-mp="2iojegyla7jqr">
            But that doesn't necessarily mean you have a <strong className="text-ink" data-id="element-307" data-mp="2no5s3950v203">practical system</strong> for
            organizing everything you need to review.
          </p>
        </div>

        <blockquote className="mt-10 border-l-4 border-brand pl-5" data-id="element-308" data-mp="3u484jytu0yvs">
          <p className="font-serif text-2xl font-bold leading-snug text-ink sm:text-[28px]" data-id="element-309" data-mp="2x5dd7dzuslk">
            That's exactly why I created Obesity Clinical Blueprint™.
          </p>
          <p className="mt-3 text-[17px] leading-relaxed text-muted" data-id="element-310" data-mp="1u2i9rk55x6n6">
            I wanted to bring the major stages of adult obesity care into one structured reference system, so you can
            organize your clinical workflow without having to build your own collection of notes, checklists, and
            templates from scratch.
          </p>
        </blockquote>
      </div>
    </Section>;
}